/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getStockData, saveWeightRatio, deviceWeightRatio } from '@/service/production/level';
import CNoData from '@/components/CNoData.vue';
import Overlay from '@/components/Overlay.vue';
import { EDeviceType } from '@/service/production/level/type';
export default defineComponent({
  name: 'StockAggregateLevel',
  components: {
    CNoData: CNoData,
    Overlay: Overlay
  },
  setup: function setup() {
    var show = ref(false);
    var showOverlay = ref(false);
    // 任意整数或小数
    var pattern = /^[0-9]*([.][0-9]{1,2})?$/;
    var dataInit = ref();
    var showPopup = function showPopup() {
      deviceWeightRatio().then(function (data) {
        dataInit.value = data.list;
      });
      show.value = true;
    };
    var onSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
        var tmp, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              tmp = [];
              for (i in values) {
                tmp.push({
                  weight_transfor_ratio: values[i],
                  device_id: i
                });
              }
              _context.next = 4;
              return saveWeightRatio(tmp);
            case 4:
              getStock();
              show.value = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onSubmit(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var stockData = ref([]);
    var getStock = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              showOverlay.value = true;
              _context2.next = 4;
              return getStockData();
            case 4:
              data = _context2.sent;
              stockData.value = data.list;
              firstLoad.value = false;
            case 7:
              _context2.prev = 7;
              showOverlay.value = false;
              return _context2.finish(7);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0,, 7, 10]]);
      }));
      return function getStock() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 分类列表
    var stockDataTypeList = computed(function () {
      var glList = [];
      var stList = [];
      stockData.value.forEach(function (item) {
        if (item.device_type === EDeviceType.gl) {
          glList.push(item);
        }
        if (item.device_type === EDeviceType.st) {
          stList.push(item);
        }
      });
      var arr = [];
      if (glList.length) {
        arr.push({
          title: '骨料',
          value: glList
        });
      }
      if (stList.length) {
        arr.push({
          title: '商砼',
          value: stList
        });
      }
      return arr;
    });
    var router = useRouter();
    var toMonitor = function toMonitor(item) {
      router.push({
        name: 'StockMonitor',
        params: {
          id: item.device_id,
          name: item.name
        }
      });
    };
    var firstLoad = ref(true);
    onMounted(function () {
      getStock();
    });
    return {
      show: show,
      pattern: pattern,
      dataInit: dataInit,
      onSubmit: onSubmit,
      showPopup: showPopup,
      stockData: stockData,
      toMonitor: toMonitor,
      firstLoad: firstLoad,
      showOverlay: showOverlay,
      stockDataTypeList: stockDataTypeList
    };
  }
});